export default __webpack_public_path__ + "static/media/021-Sunbed.a80200e5.svg";